import React, {useEffect, useState} from 'react';
import {
    Box,
    Button,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    SelectChangeEvent,
    TextField,
    Theme,
    Typography
} from '@mui/material';
import _ from 'lodash';


import makeStyles from '@mui/styles/makeStyles';


import AppBar from '../../components/appBar';
import Strings from "../../assets/strings";

import {colors} from "../../assets/colors";
// import {TextFieldPhone} from "../../components/CustomTextField";
import {editarPerfil} from "../../redux/reducers/authReducer";
import {getUsuTipo, TIPOUSUARIO} from "../../helpers";
import {MostrarError} from "../../components/MostrarError";
import {useLocation, useNavigate} from "react-router-dom";

import ChangePassword from "./ChangePassword";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {IEditUser} from "../../redux/types/IUser";
import {TextFieldPhone} from "../../components/CustomTextField";
import {SelectCaja, SelectFiles} from "../../components/selects";
import defaultImgFirma from '../../assets/img/firma.jpg';
import {Close, Save} from '@mui/icons-material';
import DeleteAccount from "./DeleteAccount";

const useStyles = makeStyles((theme:Theme) => ({

    root:{
      //  padding:theme.spacing(2),
    },
    // firma:{
    //     "& img":{
    //         maxWidth: 150,
    //         boxShadow: "0px 0px 5px #c4b9b9"
    //     }
    // },
    divColor:{
        width:"100%",
        padding: "1px 7px",
        color: "white",
    }
}));

export default function MiPerfil(){
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useAppDispatch();

    const data = useAppSelector((state) => ({
        perfil: state.auth.user,
        status: state.auth.status,
        errors: state.auth.error,
        inicioSesion: state.auth?.user?.inicioSesion
    }));

    const classes = useStyles();
    const [state, setState] = useState<IEditUser>({
        nombre: "",
        email: "",
        telefono:"",
        uiColor: "",
        cajaIdDefault: undefined,
        firma: ''
    })
    const {perfil} = data
    useEffect(()=>{
        setState(prevState =>  ({...prevState,..._.omitBy(perfil, _.isNil)}))
    },[setState,perfil])
    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>)=>{
        const {name, value} = e.target
        setState({...state, [name]: value});
    }
    const handleSelectChange = (e: SelectChangeEvent)=>{
        const {name, value} = e.target
        setState({...state, [name]: value});
    }
    const submit = (e:React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        let obj = {...state}
        if(obj.firma === perfil?.firma){
            obj.firma = "";
        }

        dispatch(editarPerfil(obj))
    }

    const {errors,status} = data;

    return(
        <>
            <AppBar />
            <div className={"contentInner "+classes.root}>
                <MostrarError errors={errors}/>
                <form id="form1" onSubmit={submit}>
                    <div className={"customCard"}>
                        <Typography color={"primary"} className={"title"}>DATOS</Typography>
                        <Grid container spacing={3} >
                            <Grid item xs={12} sm={3}>
                                <TextField
                                    name="nombre"
                                    label={Strings.primerNombre}
                                    value={state.nombre}
                                    onChange={handleChange}
                                    inputProps={{maxLength: 50}}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <TextField
                                    name="email"
                                    label={Strings.email}
                                    type="email"
                                    value={state.email}
                                    onChange={handleChange}
                                    inputProps={{maxLength: 50}}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <TextFieldPhone
                                    name="telefono"
                                    label={Strings.telefono}
                                    value={state.telefono}
                                    onChange={handleChange}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <FormControl fullWidth>
                                    <InputLabel id="uiColor">UI Color</InputLabel>
                                    <Select
                                        labelId="uiColor"
                                        name="uiColor"
                                        value={state.uiColor}
                                        onChange={handleSelectChange}
                                    >
                                        {colors.map(c=>

                                            <MenuItem key={c.primary.main} value={c.primary.main}>
                                                <div className={classes.divColor} style={{background: c.primary.main}}>{c.primary.main}</div>
                                            </MenuItem>
                                        )}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <SelectCaja label={Strings.caja+" "+Strings.porDefecto} name="cajaIdDefault" value={state.cajaIdDefault} onChange={handleChange}/>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <TextField
                                    label={Strings.nombreDeUsuario}
                                    value={data?.inicioSesion}
                                    onChange={()=>{}}
                                    disabled
                                    inputProps={{readOnly: true,}}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <TextField
                                    label={Strings.cambiar+" "+Strings.contrasena}
                                    type="password"
                                    defaultValue={"45654"}
                                    inputProps={{
                                        readOnly: true,
                                    }}
                                    fullWidth
                                    onClick={()=> navigate(location.pathname,{state:{modalChangePassword:data.inicioSesion}})}
                                />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                {/*<div className={classes.firma}>*/}
                                    <SelectFiles
                                        label={Strings.firma}
                                        output={"png"}
                                        defaultImgProp={defaultImgFirma}
                                        src={state.firma ?state.firma:""}
                                        onChange={(baseb4:string)=> {
                                        setState({...state, firma: baseb4});
                                    }}/>
                                {/*</div>*/}
                            </Grid>
                        </Grid>
                    </div>
                </form>
                <Box className={"formControl"}>
                    {getUsuTipo() === TIPOUSUARIO.titular &&
                        <Button
                            onClick={()=>navigate(location.pathname,{state:{confirmDeleteAccount:true}})}
                            sx={{marginRight:"auto"}}
                            color={"error"}
                        >Eliminar Cuenta</Button>
                    }
                    <Button sx={{mr:0.5}} color={"error"} onClick={()=>navigate(-1)} variant={"outlined"} disabled={status==="loading"} startIcon={<Close/>} size={"small"}>{Strings.cancelar}</Button>
                    <Button type={"submit"}  form={"form1"} variant={"outlined"} disabled={status==="loading"}  startIcon={<Save/>} size={"small"}>{Strings.guardar}</Button>
                </Box>
            </div>
            <ChangePassword/>

            {getUsuTipo() === TIPOUSUARIO.titular &&
                <DeleteAccount/>
            }

        </>
    );
}


// import React, {useEffect, useState} from 'react';
// import {connect} from "react-redux";
// import {
//     Grid,
//     TextField,
//     Button,
//     InputLabel,
//     FormControl,
//     Select,
//     MenuItem,
//     Typography,
// } from '@mui/material';
//
//
// import makeStyles from '@mui/styles/makeStyles';
//
//
// import AppBar from '../../components/appBar';
// import Strings from "../../assets/strings";
//
// import {colors} from "../../assets/colors";
// import {TextFieldPhone} from "../../components/CustomTextField";
// import {nullToEmptyString} from "../../helpers";
// import {MostrarError} from "../../components/MostrarError";
// import {useLocation, useNavigate} from "react-router-dom";
// import {SelectCaja, SelectFiles} from "../../components/selects";
// import defaultImgFirma from '../../assets/img/firma.jpg';
//
// import ChangePassword from "./ChangePassword";
//
// const useStyles = makeStyles(theme => ({
//
//     root:{
//         padding:theme.spacing(2),
//     },
//     firma:{
//         "& img":{
//             maxWidth: 150,
//             boxShadow: "0px 0px 5px #c4b9b9"
//         }
//     },
//
//     divColor:{
//         width:"100%",
//         padding: "1px 7px",
//         color: "white",
//     }
// }));
//
// function MiPerfil(props){
//     const navigateTo = useNavigate();
//     const {pathname} = useLocation();
//     const classes = useStyles();
//     const [state, setState] = useState({
//         id:"",
//         inicioSesion: "",
//         clave: "",
//         nombres: "",
//         usuApellidos: "",
//         email: "",
//         usuTelefono: "",
//         uiColor: "",
//         usuFirma:"",
//         cajId: props.defaultCajId,
//     })
//     const {editarPerfil, perfil} = props
//     useEffect(()=>{
//             setState(nullToEmptyString(perfil))
//     },[setState,perfil])
//     const handleChange = (e)=>{
//         const {name, value} = e.target
//         setState({...state, [name]: value});
//     }
//     const {errors,isPending} = props;
//
//     return(
//         <>
//             <AppBar title={Strings.perfil}>
//                 <Button color="inherit" disabled={isPending} type="submit" form="form1">{Strings.guardar}</Button>
//             </AppBar>
//             <div className={"contentInner "+classes.root}>
//                 <MostrarError errors={errors}/>
//                 <form id="form1" onSubmit={(e)=>{e.preventDefault();editarPerfil(state)}}>
//                     <Grid container spacing={3} className={classes.form}>
//                         <Grid item xs={12} sm={3}>
//                             <TextField
//                                 name="nombres"
//                                 label={Strings.primerNombre}
//                                 value={state.nombres}
//                                 onChange={handleChange}
//                                 inputProps={{maxLength: 50}}
//                                 fullWidth
//                             />
//                         </Grid>
//                         <Grid item xs={12} sm={3}>
//                             <TextField
//                                 name="usuApellidos"
//                                 label={Strings.apellidos}
//                                 value={state.usuApellidos}
//                                 onChange={handleChange}
//                                 inputProps={{maxLength: 50}}
//                                 fullWidth
//                             />
//                         </Grid>
//                         <Grid item xs={12} sm={3}>
//                             <TextField
//                                 name="email"
//                                 label={Strings.email}
//                                 type="email"
//                                 value={state.email}
//                                 onChange={handleChange}
//                                 inputProps={{maxLength: 50}}
//                                 fullWidth
//                             />
//                         </Grid>
//                         <Grid item xs={12} sm={3}>
//                             <TextFieldPhone
//                                 name="usuTelefono"
//                                 label={Strings.telefono}
//                                 value={state.usuTelefono}
//                                 onChange={handleChange}
//                                 fullWidth
//                             />
//                         </Grid>
//                         <Grid item xs={12} sm={3}>
//                             <FormControl fullWidth>
//                                 <InputLabel id="uiColor">UI Color</InputLabel>
//                                 <Select
//                                     labelId="uiColor"
//                                     name="uiColor"
//                                     value={state.uiColor}
//                                     onChange={handleChange}
//                                 >
//                                     {colors.map(c=>
//
//                                         <MenuItem key={c.primary.main} value={c.primary.main}>
//                                             <div className={classes.divColor} style={{background: c.primary.main}}>{c.primary.main}</div>
//                                         </MenuItem>
//                                     )}
//                                 </Select>
//                             </FormControl>
//                         </Grid>
//                         <Grid item xs={12} sm={3}>
//                             <SelectCaja label={Strings.caja+" "+Strings.porDefecto} name="cajId" value={state.cajId} onChange={handleChange}/>
//                         </Grid>
//                         <Grid item xs={12} sm={3}>
//                             <TextField
//                                 name="inicioSesion"
//                                 label={Strings.nombreDeUsuario}
//                                 value={state.inicioSesion}
//                                 onChange={handleChange}
//                                 inputProps={{readOnly: true,}}
//                                 fullWidth
//                             />
//                         </Grid>
//                         <Grid item xs={12} sm={3}>
//                             <TextField
//                                 label={Strings.cambiar+" "+Strings.contrasena}
//                                 type="password"
//                                 defaultValue={"45654"}
//                                 inputProps={{
//                                     readOnly: true,
//                                 }}
//                                 fullWidth
//                                 onClick={()=> navigateTo(pathname,{modalChangePassword:state.inicioSesion})}
//                             />
//                         </Grid>
//                         <Grid item xs={12} sm={2}>
//                             <Typography align={"center"} color={"secondary"}>{Strings.firma}</Typography>
//                             <div className={classes.firma}>
//                                 <SelectFiles output={"png"} defaultImgProp={defaultImgFirma} src={state.usuFirma ?state.usuFirma:null} onChange={(baseb4)=> {
//                                     setState({...state, usuFirma: baseb4});
//                                 }}/>
//                             </div>
//
//                             {/*<TextField*/}
//                             {/*    name="inicioSesion"*/}
//                             {/*    label={Strings.nombreDeUsuario}*/}
//                             {/*    value={state.inicioSesion}*/}
//                             {/*    onChange={handleChange}*/}
//                             {/*    inputProps={{readOnly: true,}}*/}
//                             {/*    fullWidth*/}
//                             {/*/>*/}
//                         </Grid>
//                     </Grid>
//                 </form>
//             </div>
//             <ChangePassword/>
//         </>
//     );
// }
//
// const mapStateToProps = (state) => ({
//     perfil: state.auth.user,
//     isPending: state.auth.isPending,
//     isFetching: state.auth.isFetching,
//     errors: state.auth.error,
//     defaultCajId: state.auth.user.cajId || "",
// })
// export default connect(mapStateToProps, {editarPerfil })(MiPerfil);
